import React from 'react';
import { Phone, Email, LocationOn, Schedule } from '@mui/icons-material';

const ContactInfo = () => {
    const contactMethods = [
        {
            icon: Phone,
            title: 'Support Technique',
            description: 'Pour les urgences techniques',
            details: '+243 97 000 0000',
            type: 'phone',
            color: 'from-blue-500 to-cyan-500'
        },
        {
            icon: Email,
            title: 'Email Support',
            description: 'Réponse sous 2 heures',
            details: 'support@netikash.com',
            type: 'email',
            color: 'from-amber-500 to-yellow-500'
        },
        {
            icon: LocationOn,
            title: 'Bureau Principal',
            description: 'Lubumbashi, Gambela',
            details: 'Av. kasangulu, N° 1',
            type: 'location',
            color: 'from-green-500 to-emerald-500'
        },
        {
            icon: Schedule,
            title: 'Horaires',
            description: 'Support disponible',
            details: '24h/24 - 7j/7',
            type: 'schedule',
            color: 'from-purple-500 to-pink-500'
        }
    ];

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg border border-amber-100/50 p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Informations de Contact</h3>
                <p className="text-gray-700 mb-6">
                    Plusieurs moyens de nous contacter selon la nature de votre demande.
                </p>

                <div className="space-y-4">
                    {contactMethods.map((method, index) => (
                        <div key={index} className="flex items-start space-x-4 p-4 rounded-lg bg-gray-50 hover:bg-amber-50 transition-colors group">
                            <div className={`bg-gradient-to-r ${method.color} w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                                <method.icon className="text-white text-lg" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h4 className="font-semibold text-gray-900 mb-1">{method.title}</h4>
                                <p className="text-gray-600 text-sm mb-1">{method.description}</p>
                                <p className="text-amber-700 font-medium">{method.details}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Emergency Support Card */}
            <div className="bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-2xl p-6 shadow-lg">
                <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <h4 className="font-bold text-lg">Urgence Technique</h4>
                </div>
                <p className="text-white/90 text-sm mb-4">
                    Pour les incidents critiques affectant vos transactions.
                </p>
                <div className="flex items-center justify-between">
                    <span className="font-bold text-lg">+243 90 000 0000</span>
                    <button className="bg-white text-red-600 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-colors">
                        Appeler
                    </button>
                </div>
            </div>

            {/* Social Links */}
            <div className="bg-white rounded-2xl shadow-lg border border-amber-100/50 p-6">
                <h4 className="font-semibold text-gray-900 mb-4">Suivez-nous</h4>
                <div className="flex space-x-3">
                    {[
                        { name: 'Twitter', icon: '🐦', color: 'hover:bg-blue-100' },
                        { name: 'LinkedIn', icon: '💼', color: 'hover:bg-blue-100' },
                        { name: 'GitHub', icon: '💻', color: 'hover:bg-gray-100' },
                        { name: 'YouTube', icon: '🎥', color: 'hover:bg-red-100' }
                    ].map((social, index) => (
                        <button
                            key={index}
                            className={`w-12 h-12 rounded-xl border border-gray-200 flex items-center justify-center text-lg transition-all hover:scale-110 ${social.color}`}
                        >
                            {social.icon}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;